import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createMember, inviteMember, updateMember, deleteMember, setCompanyOwner } from 'services/api/AccessManagerAPI';

// Writes of user management by product. Each refetches the member lists on
// success: the backend decides what a caller sees, so the screen re-asks
// rather than patching its copy.
const useMembersInvalidation = () => {
    const queryClient = useQueryClient();
    return () => queryClient.invalidateQueries({ queryKey: ['members'] });
};

export const useCreateMember = () => {
    const onSuccess = useMembersInvalidation();
    const { mutateAsync, isPending } = useMutation({ mutationFn: createMember, retry: false, onSuccess });
    return { createMember: mutateAsync, isPending };
};

export const useInviteMember = () => {
    const onSuccess = useMembersInvalidation();
    const { mutateAsync, isPending } = useMutation({ mutationFn: inviteMember, retry: false, onSuccess });
    return { inviteMember: mutateAsync, isPending };
};

export const useUpdateMember = () => {
    const onSuccess = useMembersInvalidation();
    const { mutateAsync, isPending } = useMutation({ mutationFn: updateMember, retry: false, onSuccess });
    return { updateMember: mutateAsync, isPending };
};

export const useDeleteMember = () => {
    const onSuccess = useMembersInvalidation();
    const { mutateAsync, isPending } = useMutation({ mutationFn: deleteMember, retry: false, onSuccess });
    return { deleteMember: mutateAsync, isPending };
};

export const useSetCompanyOwner = () => {
    const onSuccess = useMembersInvalidation();
    const { mutateAsync, isPending } = useMutation({ mutationFn: setCompanyOwner, retry: false, onSuccess });
    return { setCompanyOwner: mutateAsync, isPending };
};
